import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSidebar } from "../../context/SidebarContext";
import web_logo from '../../assets/images/web_logo.png';

import { CiCreditCard2, CiShoppingCart } from "react-icons/ci";
import { FaVectorSquare } from "react-icons/fa";
import { LiaCogSolid, LiaNetworkWiredSolid } from "react-icons/lia";
import { MdDevicesOther, MdOutlineDashboardCustomize, MdOutlineSupportAgent } from "react-icons/md";
import { PiUsersThree } from "react-icons/pi";
import { RiPagesLine } from "react-icons/ri";

import "../../styles/scrollbarStyle.css";

const BASE_SIDEBAR = [
  {
    id: "userManagement",
    name: "User Management",
    icon: <PiUsersThree size={18} />,
    innerData: [
      { id: 0, to: "/admin-panel/user/active-users/1", name: "Total Users" },
      { id: 1, to: "/admin-panel/user/blocked-users/1", name: "Blocked Users" },
      { id: 2, to: "/admin-panel/user/deleted-users/1", name: "Deleted Users" },
    ],
  },
  {
    id: "driverManagement",
    name: "Driver",
    icon: <PiUsersThree size={18} />,
    innerData: [
      { id: 0, to: "/admin-panel/driver/1", name: "Driver" },
      { id: 1, to: "/admin-panel/driver/deleted/1", name: "Deleted Drivers" },
    ],
  },
  {
    id: "assigningJobs",
    name: "Assigning Jobs",
    icon: <FaVectorSquare size={14} />,
    innerData: [], // filled from categories
  },
  {
    id: "serviceManagement",
    name: "Service Management",
    icon: <LiaNetworkWiredSolid size={18} />,
    innerData: [{ id: 0, to: "/admin-panel/categories/1", name: "Categories" }],
  },
    {
    id: "order_reports",
    name: "Order Report",
    icon: <MdOutlineSupportAgent size={18} />,
    innerData: [{ id: 0, to: "/admin-panel/order-report/1", name: "Order Report" }],
  },
  {
    id: "pricingManagement",
    name: "Pricing Management",
    icon: <LiaNetworkWiredSolid size={18} />,
    innerData: [], // filled from categories
  },
  {
    id: "orders",
    name: "Orders Management",
    icon: <CiShoppingCart size={18} />,
    innerData: [
      { id: 1, to: "/admin-panel/orders/fresh/1", name: "Fresh Orders" },
      { id: 2, to: "/admin-panel/orders/reorder/1", name: "Reorders" },
    ],
  },
  {
    id: "cancelManagement",
    name: "Cancel Management",
    icon: <CiShoppingCart size={18} />,
    innerData: [],
  },
  {
    id: "return",
    name: "Return Management",
    icon: <CiShoppingCart size={18} />,
    innerData: [],
  },
  {
    id: "banners",
    name: "Banners Management",
    icon: <RiPagesLine size={18} />,
    innerData: [], // filled from categories
  },
  {
    id: "tiffinPlan",
    name: "Plans",
    icon: <CiCreditCard2 size={18} />,
    innerData: [{ id: 0, to: "/admin-panel/tiffin-plans/1", name: "Plans" }],
  },
  {
    id: "supports",
    name: "Support Management",
    icon: <MdOutlineSupportAgent size={18} />,
    innerData: [{ id: 0, to: "/admin-panel/supports/1", name: "Help" }],
  },
  {
    id: "others",
    name: "Others",
    icon: <MdDevicesOther size={18} />,
    innerData: [
      { id: 1, to: "/admin-panel/pincodes/1", name: "Pin Codes" },
      { id: 2, to: "/admin-panel/warehouse/1", name: "Warehouse" },
      // { id: 3, to: "/admin-panel/delivery-times/edit", name: "Delivery Times" },
    ],
  },
  {
    id: "settings",
    name: "Settings",
    icon: <LiaCogSolid size={18} />,
    innerData: [
      { id: 5, to: "/admin-panel/settings", name: "Settings" },
      { id: 0, to: "/admin-panel/change-password", name: "Change Password" },
      { id: 2, to: "/admin-panel/contact-us", name: "Contact Us" },
      { id: 2, to: "/admin-panel/terms-and-conditions", name: "T&C Policy" },
      { id: 3, to: "/admin-panel/login", name: "Logout" },
    ],
  },
];

// --- Helpers ---
const cap = (s = "") => s.charAt(0).toUpperCase() + s.slice(1);
const safeName = (s = "") => encodeURIComponent(s.toLowerCase());

// Build a fresh sidebar with dynamic innerData from categories
const buildSidebarWithCategories = (categories = []) => {
  const assignJob = categories.map((item) => ({
    id: item._id,
    to: `/admin-panel/assigning-job/${safeName(item?.name)}/${item._id}/1`,
    name: cap(item?.name || ""),
  }));

  const pricing = categories
    .filter((item) => (item?.name || "").toLowerCase() !== "tiffin")
    .map((item) => ({
      id: item._id,
      to: `/admin-panel/pricing/${safeName(item?.name)}/${item._id}`,
      name: cap(item?.name || ""),
    }));

  let bannerCategoriesData = categories.map((item) => ({
    id: item._id,
    to: `/admin-panel/banners/${item._id}/1`,
    name: cap(item?.name || ""),
  }));

  let updatedBannersData = [
    {
      id: "123456789",
      to: `/admin-panel/banners/123456789/1`,
      name: "Home Banner",
    },
    ...bannerCategoriesData,
  ];

  let updatedReturnList = [];

  const updatedCancelList = categories?.map((item) => ({
    id: item._id,
    to: `/admin-panel/cancel/${safeName(item?.name)}/${item._id}/1`,
    name: cap(item?.name || ""),
  }));

  const updatedOrdersListData = categories?.map(
    (item) => {
      if (["water", "oxygen"].includes(item?.name?.toLowerCase())) {
        updatedReturnList = [...updatedReturnList, {
          id: item._id,
          to: `/admin-panel/returns/${item?.name?.toLowerCase() === "water" ? "0" : "1"}/1`,
          name:
            item?.name?.slice(0, 1)?.toUpperCase() + item?.name?.slice(1),
        }]
      }

      return {
        id: item._id,
        to: `/admin-panel/order/${item._id}/1`,
        name:
          item?.name?.slice(0, 1)?.toUpperCase() + item?.name?.slice(1),
      };
    }
  );

  let updatedOrdersData = [
    ...updatedOrdersListData,
    {
      id: 10,
      to: "/admin-panel/orders/fresh/1",
      name: "Fresh Orders",
    },
    {
      id: 11,
      to: "/admin-panel/orders/reorder/1",
      name: "Reorders",
    },
  ];


  // Deep copy base and inject
  const updated = BASE_SIDEBAR.map((it) => ({ ...it, innerData: [...(it.innerData || [])] }));
  updated.forEach((section) => {
    if (section.id === "assigningJobs") section.innerData = assignJob;
    if (section.id === "pricingManagement") section.innerData = pricing;
    if (section.id === "banners") section.innerData = updatedBannersData;
    if (section.id === "orders") section.innerData = updatedOrdersData;
    if (section.id === "return") section.innerData = updatedReturnList;
    if (section.id === "cancelManagement") section.innerData = updatedCancelList;
  });

  return updated;
};

const filterByPermissions = (sidebar, permissions = {}) =>
  sidebar.filter((item) => permissions?.[item.id] === true);

export default function Sidebar() {
  const { sidebarWidth, openedList, handleOpenedList } = useSidebar();
  const [activeList, setActiveList] = useState(openedList || "");
  const [sidebarData, setSidebarData] = useState(BASE_SIDEBAR);
  const [userPermissions, setUserPermissions] = useState({});
  const sidebarRef = useRef(null);
  const navigate = useNavigate();

  const role = localStorage.getItem("role") || "admin";

  useEffect(() => {
    const load = async () => {
      try {
        const token = localStorage.getItem("sansadToken");
        const headers = {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        // 1) Fetch in parallel
        const [permRes, catRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/get-user-data`, { headers }),
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/category/view-all-categories?status=Active&page=1&limit=1000`, { headers }),
        ]);

        // 2) Extract data safely
        const permissionsMap = permRes?.data?.result?.user?.[0]?.permissions || {};
        const categories = catRes?.data?.result?.categories || [];

        setUserPermissions(permissionsMap);

        // 3) Build dynamic inner data first
        const dynamicSidebar = buildSidebarWithCategories(categories);

        // 4) Then apply permissions
        const finalSidebar = filterByPermissions(dynamicSidebar, permissionsMap);

        setSidebarData(finalSidebar);
        setActiveList(openedList || ""); // keep in sync with context if needed
      } catch (err) {
        console.log("Sidebar init error:", err);
        // Fallback: show base without filtering to avoid empty UI
        setSidebarData(BASE_SIDEBAR);
      }
    };

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once

  const handleSidebarListToggle = (listId) => {
    if (listId === activeList) {
      handleOpenedList("");
      setActiveList("");
    } else {
      handleOpenedList(listId);
      setActiveList(listId);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("sansadToken");
    navigate("/admin-panel/login");
  };

  return (
    <div
      ref={sidebarRef}
      className={`bg-[#fff] ${sidebarWidth === "0px" ? "w-[0px] hidden" : "w-[280px]"} h-screen shadow-xl fixed flex flex-col bg-white z-10 transition-all duration-300`}
    >
      <div className="border-b h-[80px] flex justify-center items-center">
        <img src={web_logo} alt="web logo" className="w-[50px] h-[50px] rounded-full mr-2" />
        <h2 className="text-xl font-semibold">SANSAR SADASYA</h2>
      </div>

      <div className="overflow-y-auto overscroll-contain custom-scrollbar h-[calc(100%-140px)] flex flex-col gap-3 py-8">
        <Link
          to="/admin-panel/dashboard"
          className="w-full flex justify-center"
          onClick={() => handleSidebarListToggle("dashboard")}
        >
          <button
            className={`${activeList === "dashboard" ? "bg-[#3d0000] text-white" : "bg-[#f1f1f1] text-black"} hover:bg-[#3d0000] hover:text-white w-[92%] py-3 px-3 rounded-md text-[13px] flex justify-start items-center cursor-pointer !outline-none`}
          >
            <MdOutlineDashboardCustomize size={16} />
            <span className="ml-2">Dashboard</span>
          </button>
        </Link>

        {role === "super-admin" && (
          <Link
            to="/admin-panel/adminuser/1"
            className="w-full flex justify-center"
            onClick={() => handleSidebarListToggle("adminuser")}
          >
            <button
              className={`${activeList === "adminuser" ? "bg-[#3d0000] text-white" : "bg-[#f1f1f1] text-black"} hover:bg-[#3d0000] hover:text-white w-[92%] py-3 px-3 rounded-md text-[13px] flex justify-start items-center cursor-pointer !outline-none`}
            >
              <MdOutlineDashboardCustomize size={16} />
              <span className="ml-2">Admin Users</span>
            </button>
          </Link>
        )}

        {sidebarData?.map((data) => (
          <div key={data.id} className="w-full flex flex-col items-center">
            <button
              className={`${activeList === data.id ? "bg-[#3d0000] text-white" : "bg-[#f1f1f1] text-black"} hover:bg-[#3d0000] hover:text-white w-[92%] py-3 px-3 rounded-md text-[13px] tracking-wide flex justify-between cursor-pointer`}
              onClick={() => handleSidebarListToggle(data.id)}
            >
              <div className="flex gap-2 items-center">
                {data.icon}
                <span>{data.name}</span>
              </div>
              <span>{activeList === data.id ? <i className="fa fa-caret-down" /> : <i className="fa fa-caret-right" />}</span>
            </button>

            {activeList === data.id && (
              <div className="bg-[#f5f4f4] rounded-md mt-2 w-full tracking-wide max-h-[400px] overflow-y-auto overscroll-contain module-scrollbar">
                {(data.innerData || []).map((item) => (
                  <Link
                    key={item.id || item.to}
                    to={item.to}
                    className="py-3 px-3 text-black text-sm cursor-pointer hover:bg-[#eee] hover:text-black flex items-center"
                  >
                    <span className="text-[13px] no-underline">
                      <i className="fa fa-circle-o mx-2"></i> {item.name}
                    </span>
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="py-3 px-3 text-black text-sm cursor-pointer hover:bg-[#eee] block flex justify-end items-center w-full h-[40px]">
        <span onClick={handleLogout} className="tracking-wide font-medium">Log Out</span>
        <i className="fa fa-sign-out ml-3"></i>
      </div>
    </div>
  );
}
